import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ModalContentKey =
  | "applyCoupon"
  | "shippingCalculator"
  | "legalAgreements"
  | "paymentForm"
  | "stockNotification"
  | "cookiePreferences";

export interface OpenGlobalModalPayload {
  contentKey: ModalContentKey;
  title: string;
  contentProps?: any; // Optional props to pass to the content component
}

export interface GlobalModalState {
  isOpen: boolean;
  contentKey: ModalContentKey | null;
  title: string;
  contentProps: any;
}

const initialState: GlobalModalState = {
  isOpen: false,
  contentKey: null,
  title: "",
  contentProps: {},
};

export const globalModalSlice = createSlice({
  name: "globalModal",
  initialState,
  reducers: {
    openGlobalModal: (state, action: PayloadAction<OpenGlobalModalPayload>) => {
      state.isOpen = true;
      state.contentKey = action.payload.contentKey;
      state.title = action.payload.title;
      state.contentProps = action.payload.contentProps || {};
    },
    closeGlobalModal: (state) => {
      state.isOpen = false;
      // Reset state on close for a clean slate next time
      state.contentKey = null;
      state.title = "";
      state.contentProps = {};
    },
  },
});

export const { openGlobalModal, closeGlobalModal } = globalModalSlice.actions;

export default globalModalSlice.reducer;
